export const SEND_OPEN_POOL_REQUESTS_SUCCESS = 'SEND_OPEN_POOL_REQUESTS_SUCCESS';

export const sendOpenPoolRequestsSuccess = () => ({
    type: SEND_OPEN_POOL_REQUESTS_SUCCESS,
});
